export enum EnvironmentName {
  DEVELOPMENT = 'development',
  DEVELOP = 'develop',
  STAGING = 'staging',
  PRODUCTION = 'production'
}
